<template>
  <v-snackbar
    :timeout="timeout"
    v-model="snackbar"
    top
    left
  >
    <span class="white--text">{{text}}</span>
    <v-btn dark flat icon color="blue" @click="snackbar = false">
      <v-icon>close</v-icon></v-btn>
  </v-snackbar>
</template>

<script>

export default {
  data() {
    return {
      timeout: 0,
      show: true,
    };
  },
  computed: {
    text() {
      return `Download speed: ${this.$store.state.downlink} Mbps`;
    },
    snackbar: {
      get() {
        return (this.show && !!this.$store.state.downlink);
      },
      set(val) {
        this.show = val;
      },
    },
  },
};
</script>
